import { IForm } from '@/components/types'

export const modalConfig: IForm = {
  formItems: [
    {
      field: 'corpId',
      type: 'select',
      label: '主体',
      placeholder: '请选择主体',
      filterable: true,
      clearable: true,
      options: []
    },
    {
      field: 'thirdParty',
      type: 'select',
      label: '所属第三方',
      placeholder: '请选择所属第三方',
      filterable: true,
      clearable: true,
      options: [
        { title: '半马星', value: '半马星' },
        { title: '烜颐融', value: '烜颐融' },
        { title: '与牛共行', value: '与牛共行'},
      ]
    },
    {
      field: 'workAccount',
      type: 'input',
      label: '工作账号',
      placeholder: '请输入工作账号'
    },
    {
      field: 'startDate',
      type: 'datepicker',
      label: '承接资源开始日期',
      placeholder: '请选择开始日期',
      otherOptions: {
        type: 'date',
        'value-format': 'YYYY-MM-DD'
      }
    },
    {
      field: 'endDate',
      type: 'datepicker',
      label: '承接资源结束日期',
      placeholder: '请选择结束日期',
      otherOptions: {
        type: 'date',
        'value-format': 'YYYY-MM-DD'
      }
    }
  ],
  colLayout: 24
}

